import React from 'react';

// Coin icon with "R" for South African Rand — replaces $ icon that confused users
const CoinIcon = ({ size = 16, color = 'currentColor', style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, ...style }}
  >
    {/* Outer coin circle */}
    <circle cx="12" cy="12" r="10" />
    {/* Inner rim */}
    <circle cx="12" cy="12" r="7" strokeWidth="1" opacity="0.5" />
    {/* R letter */}
    <text
      x="12"
      y="17"
      textAnchor="middle"
      fontSize="11"
      fontWeight="bold"
      stroke="none"
      fill={color}
      fontFamily="Inter, system-ui, sans-serif"
    >
      R
    </text>
  </svg>
);

export default CoinIcon;
